(function () {
  const TOWER_GARDEN_PRODUCT_IDS = [
    8482658713830,
    8639835603174,
    8639836422374,
    8639835275494,
    8639837208806,
    8639835996390,
    8639836520678,
    8973658030310,
    9611886133478,
    9606259540198,
    9606257148134
  ];

  const POD_SQUAD_VARIANT_ID = 48094948098278;
  const POD_SQUAD_SELLING_PLAN_ID = 7621673190;

  // The "__" suffix makes this a private Shopify cart attribute.
  const POD_SQUAD_OPT_OUT_ATTRIBUTE = 'pod_squad_opted_out__';

  const originalFetch = window.fetch.bind(window);
  let isSyncing = false;

  function hasTowerGarden(cart) {
    return cart.items.some(item =>
      TOWER_GARDEN_PRODUCT_IDS.includes(Number(item.product_id))
    );
  }

  function hasPodSquad(cart) {
    return cart.items.some(item =>
      Number(item.variant_id) === POD_SQUAD_VARIANT_ID
    );
  }

  function hasOptedOut(cart) {
    return cart.attributes?.[POD_SQUAD_OPT_OUT_ATTRIBUTE] === 'true';
  }

  async function getCart() {
    const response = await originalFetch('/cart.js');

    if (!response.ok) {
      throw new Error(`Unable to retrieve cart: ${response.status}`);
    }

    return response.json();
  }

  async function recordPodSquadOptOut() {
    const response = await originalFetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        attributes: {
          [POD_SQUAD_OPT_OUT_ATTRIBUTE]: 'true'
        }
      })
    });

    if (!response.ok) {
      throw new Error(`Unable to record Pod Squad opt-out: ${response.status}`);
    }
  }

  async function syncPodSquad(cart) {
    if (isSyncing) return;

    isSyncing = true;

    try {
      cart = cart || await getCart();

      if (
        hasTowerGarden(cart) &&
        !hasPodSquad(cart) &&
        !hasOptedOut(cart)
      ) {
        const response = await originalFetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            items: [
              {
                id: POD_SQUAD_VARIANT_ID,
                quantity: 1,
                selling_plan: POD_SQUAD_SELLING_PLAN_ID
              }
            ]
          })
        });

        if (!response.ok) {
          throw new Error(`Unable to add Pod Squad: ${response.status}`);
        }
      }
    } catch (error) {
      console.error('Pod Squad sync failed:', error);
    } finally {
      isSyncing = false;
    }
  }

  window.fetch = async function (...args) {
    const url =
      typeof args[0] === 'string'
        ? args[0]
        : args[0]?.url || '';

    const isCartMutation =
      url.includes('/cart/add') ||
      url.includes('/cart/change') ||
      url.includes('/cart/update') ||
      url.includes('/cart/clear');

    if (!isCartMutation) {
      return originalFetch(...args);
    }

    let cartBeforeMutation;

    try {
      cartBeforeMutation = await getCart();
    } catch (error) {
      console.warn('Could not inspect cart before mutation:', error);
    }

    const result = await originalFetch(...args);

    if (!result.ok) {
      return result;
    }

    try {
      const cartAfterMutation = await getCart();

      // A Pod Squad item existed before this cart action but no longer
      // exists afterward, so treat that removal as an intentional opt-out.
      const removedPodSquad =
        cartBeforeMutation &&
        hasPodSquad(cartBeforeMutation) &&
        !hasPodSquad(cartAfterMutation);

      if (removedPodSquad) {
        await recordPodSquadOptOut();
      } else {
        await syncPodSquad(cartAfterMutation);
      }
    } catch (error) {
      console.error('Pod Squad cart handling failed:', error);
    }

    return result;
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => syncPodSquad());
  } else {
    syncPodSquad();
  }
})();